/*eslint-disable*/
function language($translateProvider) {

	$translateProvider.translations("pt-BR", {
		"AMOSTRA": "AMOSTRA",
		"DATACOLETA": "Data da Coleta",
		"CT_RESULTADO": "Resultado",
		"CT_GRANDES": "Grandes",
		"CT_PEQUENOS": "Pequenos",
		"CT_DILUICAO": "Fator",
		"ECOLI_RESULTADO": "Resultado",
		"ECOLI_GRANDES": "Grandes",
		"ECOLI_PEQUENOS": "Pequenos",
		"ECOLI_DILUICAO": "Fator",
		"AMOSTRAS_TITLE": "Amostra {{currentData.AMOSTRA}}",
		"DETAILVIEW": "Detalhes da Amostra",
		"FATORDILUPADRAO": "Fator",
		"CT": "Coliformes Totais",
		"ECOLI": "E. coli",
		"DATE_FORMAT": "dd/MM/yyyy",
		"OPERATION": "Operação",
		"CONFIGURATION": "Configurações",
		"MARCACOES": "Marcações",
		"REGISTER": "Registro",
		"NAME_LOGIN": "Nome de usuário",
		"NAME_ANALYST": "Analista",
		"ANALISTAS_TITLE": "Analista {{currentData.NOME}}",
		"CLICK_CAPTURE": "Clique para capturar",
		"CHANGE_RESULT_BTN": "Alterar contagem manualmente",
		"LOADING": "Carregando...",
		"ANIMATION": "Animação",
		"LARGE_WELLS": "Poços grandes positivos: ",
		"SMALL_WELLS": "Poços pequenos positivos: ",
		"RESULT_WELLS": "Número mais provável (NMP): ",
		"CHANGE_CONFIRMATION": "Deseja realmente alterar manualmente a contagem?",
		"CAPTURING": "Capturando imagens...",
		"CAPTURE": "Capturar imagens",
		"PADRAO": "Padrão",
		"POSITIVE": "Positiva",
		"NEGATIVE": "Negativa",
		"CLOSE": "Fechar",
		"SAVE_AND_CLOSE": "Salvar e fechar",
		"REGISTRO_SALVO": "Salvo com sucesso!",
		"ERRO_AO_SALVAR": "Erro ao tentar salvar!",
		"CALIBRACAO_TITLE": "Calibração",
		"NEXT": "Próximo",
		"FINISH": "Finalizar",
		"PREVIOUS": "Anterior",
		"CALIBRACAO": "Calibração",
		"CARD_POSI_BUTTON": "Coloque a cartela positiva e pressione OK",
		"CARD_NEG_BUTTON": "Coloque a cartela negativa e pressione OK",
		"CARD_STAND_BUTTON": "Coloque a cartela padrão e pressione OK",
		"RECAPTURE": "Recapturar imagem",
		"ENDERECOUNILIMS": "Endereço do servidor de aplicação UniLIMS",
		"PASSWORD": "Senha",
		"NAME_ACCESS": "Nome access point SID",
		"PASSWORD_ACCESS": "Senha access point",
		"INTEGRATION_CHECKBOX": "Integração com UniLIMS",
		"ENABLE_ACCESS_CHECKBOX": "Habilitar access point SID",
		"ACCESS_POINT": "Access Point",
		"TIMEZONE": "Fuso horário",
		"ENABLE_TIMEZONE_CHECKBOX": "Alterar fuso horário",
		"POSITION_X": "Posição X:",
		"POSITION_Y": "Posição Y:",
		"WIDTH": "Largura:",
		"HEIGHT": "Altura:",
		"GROUP": "Grupo:",
		"DEFAULT_MARKED": "Marcado por padrão:",
		"WELLS": "Poços",
		"CARD": "Cartela",
		"DESCAMOSTRA": "Descrição",
		"RECAPTURING": "Recapturando...",
		"UNILIMS_INTEGRATION_SUCCESS": "Integração com UniLims alterada com sucesso!",
		"UNILIMS_INTEGRATION_FAIL": "Não foi possível fazer a integração com UniLims!",
		"ACCESS_POINT_SUCCESS": "WiFi configurado com sucesso",
		"ACCESS_POINT_FAIL": "Não foi possivel fazer a configuração do WiFi",
		"TIMEZONE_SUCCESS": "Fuso horário alterado com sucesso!",
		"TIMEZONE_FAIL": "Não foi possivel alterar o fuso horário!",
		"WIFI_OFF": "WiFi desligado!",
		"MIN_CARAC_SENHA": "A senha deve conter no mínimo 8 caracteres",
		"FAIL_TO_LOAD_JSON": "Falha ao carregar JSON",
		"FIELD_REQUIRED": "Campo obrigatório",
		"INVALID_FORM": "Entradas inválidas",
		"AMOSTRA_TRAY": "Amostra",
		"CONFIRM_UV_EDIT": "Esse poço é negativo para Coliformes, deseja realmente marcar? (Ele será marcado para as duas análises Coliformes e E. coli)",
		"CONFIRM_RGB_EDIT": "Esse poço é positivo para E. coli, deseja realmente desmarcar? (Ele será desmarcado para as duas análises Coliformes e E. coli)",
		"MARCACOES_TITLE": "Marcações",
		"QR_CODE": "QRCode",
		"ERRO_INESPERADO_TENTE_NOMAMENTE": "Erro inesperado, tente novamente mais tarde",
		"ENDERECOMOBSERVICE": "Endereço do servidor de aplicação",
		"ANIMATION_CHECKBOX": "Habilitar animação da contagem",
		"NEW_VERSION": "Nova versão",
		"UPDATE": "Atualizar",
		"UPDATING": "Atualizando",
		"DOWNLOADING": "Baixando",
		"EXTRACTING": "Extraindo",
		"ALREADY_UPDATED": "Atualizado",
		"UPDATE_WAIT_MESSAGE": "Aguarde enquanto a aplicação é reiniciada",
		"LOGIN_LABEL": "Login",
		"SYSTEM_CONFIGURATION": "Configurações de Sistema",
		"CAMERA_RGB_OPTIONS": "Opções da foto com luz LED",
		"CAMERA_UV_OPTIONS": "Opções da foto com luz UV",
		"OPT_ROI_DESCRIPTION": "Região de interesse (ROI)",
		"OPT_TIMEOUT_DESCRIPTION": "Tempo de delay (em milisegundos)",
		"OPT_ISO_DESCRIPTION": "ISO",
		"OPT_AWBG_DESCRIPTION": "Balanço do Branco manual",
		"OPT_AWB_DESCRIPTION": "Balanço do Branco automático",
		"OPT_SS_DESCRIPTION": "Velocidade do obturador (em microsegundos)",
		"OPT_CUSTOMARGS_DESCRIPTION": "Argumentos opcionais",
		"MENU_CHECKBOX": "Habilitar menus de sistema",
		"COUNTRY": "País",
		"GERAL": "Geral",
		"PADRAO_UNI": "Padrão",
		"NEW" : "Novo",
        "INSERT" : "Inserir",
        "DESCRIPTION" : "Descrição",
        "NUMBER" : "Número",
        "ACTIVELOW" : "Ativa com sinal LOW",
		"LIGHTING" : "Iluminação",
        "OUTPUT_GPIOS" : "GPIOs de saida",
		"CT_DHINIANALI" : "Início do ensaio",
		"CT_DHFIMANALI" : "Final do ensaio",
		"ECOLI_DHINIANALI" : "Início do ensaio",
		"ECOLI_DHFIMANALI" : "Final do ensaio",
		"DATE_TIME_FORMAT": "dd/MM/yyyy HH:mm",
		"ETIQUETAS": "Etiquetas",
		"EDIT_LOTE": "Edição em lote",
		"PRINT_LABELS": "Gerar PDF",
		"ADD_ETIQUETAS": "Adicionar etiquetas",
		"ETIQUETAS_PRINT_IN_PROGRESS": "As etiquetas estão sendo impressas",
		"NECESSARY_INPUT_ETIQUETA": "Nenhuma etiqueta encontrada, por favor adicione uma etiqueta",
		"DISABLE_EMPTY_ETIQUETA": "Preencha todas as etiquetas"
	});

	$translateProvider.translations("en-US", {
		"AMOSTRA": "SAMPLE ID",
		"DATACOLETA": "Collection Date",
		"CT_RESULTADO": "Final Amount",
		"CT_GRANDES": "Large",
		"CT_PEQUENOS": "Small",
		"CT_DILUICAO": "Factor",
		"ECOLI_RESULTADO": "Final Amount",
		"ECOLI_GRANDES": "Large",
		"ECOLI_PEQUENOS": "Small",
		"ECOLI_DILUICAO": "Factor",
		"AMOSTRAS_TITLE": "Sample ID {{currentData.AMOSTRA}}",
		"DETAILVIEW": "Sample Details",
		"FATORDILUPADRAO": "Factor",
		"CT": "Total Coliforms",
		"ECOLI": "E. coli",
		"DATE_FORMAT": "MM/dd/yyyy",
		"OPERATION": "Operation",
		"CONFIGURATION": "Settings",
		"MARCACOES": "Markings",
		"REGISTER": "Record",
		"NAME_LOGIN": "Username",
		"NAME_ANALYST": "Analyst",
		"ANALISTAS_TITLE": "Analyst {{currentData.NOME}}",
		"CLICK_CAPTURE": "Click to capture",
		"CHANGE_RESULT_BTN": "Change the count manually",
		"LOADING": "Loading...",
		"ANIMATION": "Animation",
		"LARGE_WELLS": "Positive Large Wells: ",
		"SMALL_WELLS": "Positive Small Wells: ",
		"RESULT_WELLS": "Most Probable Number (MPN): ",
		"CHANGE_CONFIRMATION": "Do you want to manually change the count?",
		"CAPTURING": "Capturing images...",
		"CAPTURE": "Capture images",
		"PADRAO": "Standard",
		"POSITIVE": "Positive",
		"NEGATIVE": "Negative",
		"CLOSE": "Close",
		"SAVE_AND_CLOSE": "Save and close",
		"REGISTRO_SALVO": "Saved successfully!",
		"ERRO_AO_SALVAR": "An error occured while saving!",
		"CALIBRACAO_TITLE": "Calibration",
		"NEXT": "Next",
		"FINISH": "Finish",
		"PREVIOUS": "Previous",
		"CALIBRACAO": "Calibration",
		"CARD_POSI_BUTTON": "Put the Positive Tray and press OK",
		"CARD_NEG_BUTTON": "Put the Negative Tray and press OK",
		"CARD_STAND_BUTTON": "Put the Standard Tray and press OK",
		"RECAPTURE": "Recapture image",
		"ENDERECOUNILIMS": "UniLIMS Application Server adress",
		"PASSWORD": "Password",
		"NAME_ACCESS": "SID Access Point name",
		"PASSWORD_ACCESS": "SID Access Point password",
		"INTEGRATION_CHECKBOX": "UniLIMS Integration",
		"ENABLE_ACCESS_CHECKBOX": "Enable SID Access Point",
		"ACCESS_POINT": "Access Point",
		"TIMEZONE": "Time Zone",
		"ENABLE_TIMEZONE_CHECKBOX": "Change the time zone",
		"POSITION_X": "Position X:",
		"POSITION_Y": "Position Y:",
		"WIDTH": "Width:",
		"HEIGHT": "Height:",
		"GROUP": "Group:",
		"DEFAULT_MARKED": "Marked by default:",
		"WELLS": "Wells",
		"CARD": "Tray",
		"DESCAMOSTRA": "Description",
		"RECAPTURING": "Recapturing...",
		"UNILIMS_INTEGRATION_SUCCESS": "UniLims Integration changed successfully!",
		"UNILIMS_INTEGRATION_FAIL": "An error occured while changing the UniLims Integration!",
		"ACCESS_POINT_SUCCESS": "Access Point configured successfully",
		"ACCESS_POINT_FAIL": "An error occured while configuring the Access Point!",
		"TIMEZONE_SUCCESS": "Time zone changed successfully!",
		"TIMEZONE_FAIL": "An error occured while changing the time zone!",
		"WIFI_OFF": "Access Point is turned off!",
		"MIN_CARAC_SENHA": "Password must have at least 8 characters",
		"FAIL_TO_LOAD_JSON": "Loading JSON failed",
		"FIELD_REQUIRED": "Mandatory field",
		"INVALID_FORM": "Invalid entries",
		"AMOSTRA_TRAY": "Sample ID",
		"CONFIRM_UV_EDIT": "This well is negative for Coliforms, do you really want to mark it? (It will be marked for both Coliforms and E. coli analyses)",
		"CONFIRM_RGB_EDIT": "This well is positive for E. coli, do you really want to unmark it? (It will be unmarked for both Coliforms and E. coli analyses)",
		"MARCACOES_TITLE": "Markings",
		"QR_CODE": "QRCode",
		"ERRO_INESPERADO_TENTE_NOMAMENTE": "Unexpected error, please try again later",
		"ENDERECOMOBSERVICE": "Application Server adress",
		"ANIMATION_CHECKBOX": "Enable count animation",
		"NEW_VERSION": "New version",
		"UPDATE": "Update",
		"UPDATING": "Updating",
		"DOWNLOADING": "Downloading",
		"EXTRACTING": "Extracting",
		"ALREADY_UPDATED": "Updated",
		"UPDATE_WAIT_MESSAGE": "Please wait while the application is restarting",
		"LOGIN_LABEL": "Login",
		"SYSTEM_CONFIGURATION": "System Settings",
        "CAMERA_RGB_OPTIONS": "LED Light Photo options",
        "CAMERA_UV_OPTIONS": "UV Light Photo options",
        "OPT_ROI_DESCRIPTION": "Region of Interest (ROI)",
        "OPT_TIMEOUT_DESCRIPTION": "Delay Time (in milliseconds)",
        "OPT_ISO_DESCRIPTION": "ISO",
        "OPT_AWBG_DESCRIPTION": "Manual White Balance",
        "OPT_AWB_DESCRIPTION": "Auto White Balance",
        "OPT_SS_DESCRIPTION": "Shutter Speed (in microseconds)",
        "OPT_CUSTOMARGS_DESCRIPTION": "Optional arguments",
		"MENU_CHECKBOX": "Enable system menus",
		"COUNTRY": "Country",
		"GERAL": "General",
		"PADRAO_UNI": "Standard",
        "NEW" : "New",
        "INSERT" : "Insert",
        "DESCRIPTION" : "Description",
        "NUMBER" : "Number",
        "ACTIVELOW" : "Active on LOW signal",
        "LIGHTING" : "Lighting",
        "OUTPUT_GPIOS" : "GPIOs for output",
		"CT_DHINIANALI" : "Beginning of the test",
		"CT_DHFIMANALI" : "End of the test",
		"ECOLI_DHINIANALI" : "Beginning of the test",
		"ECOLI_DHFIMANALI" : "End of the test",
		"DATE_TIME_FORMAT": "dd/MM/yyyy HH:mm",
		"ETIQUETAS": 'Labels',
		"EDIT_LOTE": "Batch editing",
		"PRINT_LABELS": "Generate PDF",
		"ADD_ETIQUETAS": "Add labels",
		"ETIQUETAS_PRINT_IN_PROGRESS": "Labels are being printed",
		"NECESSARY_INPUT_ETIQUETA": 'No labels found, please add a label',
		"DISABLE_EMPTY_ETIQUETA": "Fill in all labels"
	});

	$translateProvider.translations("es-ES", {
		"AMOSTRA": "MUESTRA",
		"DATACOLETA": "Fecha de la recolección",
		"CT_RESULTADO": "Resultado",
		"CT_GRANDES": "Grandes",
		"CT_PEQUENOS": "Pequeños",
		"CT_DILUICAO": "Factor",
		"ECOLI_RESULTADO": "Resultado",
		"ECOLI_GRANDES": "Grandes",
		"ECOLI_PEQUENOS": "Pequeños",
		"ECOLI_DILUICAO": "Factor",
		"AMOSTRAS_TITLE": "Muestra {{currentData.AMOSTRA}}",
		"DETAILVIEW": "Detalle",
		"FATORDILUPADRAO": "Factor",
		"CT": "Coliformes totales",
		"ECOLI": "E. coli",
		"DATE_FORMAT": "dd/MM/yyyy",
		"OPERATION": "Operación",
		"CONFIGURATION": "Ajustes",
		"MARCACOES": "Marcaciónes",
		"REGISTER": "Registro",
		"NAME_LOGIN": "Nombre de usuario",
		"NAME_ANALYST": "Analista",
		"ANALISTAS_TITLE": "Analista {{currentData.NOME}}",
		"CLICK_CAPTURE": "Haga clic para capturar",
		"CHANGE_RESULT_BTN": "Cambiar el recuento manualmente",
		"LOADING": "Cargando...",
		"ANIMATION": "Animación",
		"LARGE_WELLS": "Pocillos grandes positivos: ",
		"SMALL_WELLS": "Pocillos pequeños positivos: ",
		"RESULT_WELLS": "Número Más Probable (NMP): ",
		"CHANGE_CONFIRMATION": "¿Realmente quieres cambiar manualmente el recuento?",
		"CAPTURING": "Capturando imágenes...",
		"CAPTURE": "Capturar imágenes",
		"PADRAO": "Estándar",
		"POSITIVE": "Positiva",
		"NEGATIVE": "Negativa",
		"CLOSE": "Cerrar",
		"SAVE_AND_CLOSE": "Guardar y cerrar",
		"REGISTRO_SALVO": "Guardado con éxito",
		"ERRO_AO_SALVAR": "Error al intentar guardar!",
		"CALIBRACAO_TITLE": "Calibración",
		"NEXT": "Siguiente",
		"FINISH": "Terminar",
		"PREVIOUS": "Anterior",
		"CALIBRACAO": "Calibración",
		"CARD_POSI_BUTTON": "Ponga la bandeja positiva y pulse OK",
		"CARD_NEG_BUTTON": "Ponga la bandeja negativa y pulse OK",
		"CARD_STAND_BUTTON": "Ponga la bandeja estándar y pulse OK",
		"RECAPTURE": "Recapturar imagen",
		"ENDERECOUNILIMS": "Dirección del servidor de aplicación UniLIMS",
		"PASSWORD": "Contraseña",
		"NAME_ACCESS": "Nombre del access point SID",
		"PASSWORD_ACCESS": "Contraseña del access point",
		"INTEGRATION_CHECKBOX": "Integración con UniLIMS",
		"ENABLE_ACCESS_CHECKBOX": "Habilitar access point SID",
		"ACCESS_POINT": "Access Point",
		"TIMEZONE": "Huso horario",
		"ENABLE_TIMEZONE_CHECKBOX": "Cambiar huso horario",
		"POSITION_X": "Posición X:",
		"POSITION_Y": "Posición Y:",
		"WIDTH": "Anchura:",
		"HEIGHT": "Altura:",
		"GROUP": "Grupo:",
		"DEFAULT_MARKED": "Marcado por estándar:",
		"WELLS": "Pocillos",
		"CARD": "Bandeja",
		"DESCAMOSTRA": "Descripción",
		"RECAPTURING": "Recapturando...",
		"UNILIMS_INTEGRATION_SUCCESS": "Integración con UniLims cambiada con éxito!",
		"UNILIMS_INTEGRATION_FAIL": "No se pudo hacer la integración con UniLims!",
		"ACCESS_POINT_SUCCESS": "WiFi configurado con éxito",
		"ACCESS_POINT_FAIL": "No se pudo hacer la configuración del WiFi",
		"TIMEZONE_SUCCESS": "Huso horario cambiado con éxito!",
		"TIMEZONE_FAIL": "No se pudo cambiar lo huso horario!",
		"WIFI_OFF": "WiFi apagado!",
		"MIN_CARAC_SENHA": "La contraseña debe tener como mínimo 8 caracteres",
		"FAIL_TO_LOAD_JSON": "No se pudo cargar JSON",
		"FIELD_REQUIRED": "Campo obligatorio",
		"INVALID_FORM": "Entradas no válidas",
		"AMOSTRA_TRAY": "Muestra",
		"CONFIRM_UV_EDIT": "Este pocillo es negativo para Coliformes, desea realmente marcar? (Se marcará para los dos análisis Coliformes y E. coli)",
		"CONFIRM_RGB_EDIT": "Este pocilo es positivo para E. coli, desea realmente desmarcar (Se desmarcará para los dos análisis Coliformes y E. coli)",
		"MARCACOES_TITLE": "Marcaciónes",
        "QR_CODE": "QRCode",
        "ERRO_INESPERADO_TENTE_NOMAMENTE": "Error inesperado, vuelva a intentarlo más tarde",
		"ENDERECOMOBSERVICE": "Dirección del servidor de aplicación",
		"ANIMATION_CHECKBOX": "Habilitar animación del recuento",
		"NEW_VERSION": "Nueva versión",
		"UPDATE": "Actualizar",
		"UPDATING": "Actualizando",
		"DOWNLOADING": "Descargando",
		"EXTRACTING": "Extrayendo",
		"ALREADY_UPDATE": "Actualizado",
		"UPDATE_WAIT_MESSAGE": "Espere mientras la aplicación se reinicia",
		"LOGIN_LABEL": "Login",
		"SYSTEM_CONFIGURATION": "Configuración del sistema",
		"CAMERA_RGB_OPTIONS": "Opciones de la foto con luz LED",
		"CAMERA_UV_OPTIONS": "Opciones de la foto con luz UV",
		"OPT_ROI_DESCRIPTION": "Región de interés (ROI)",
		"OPT_TIMEOUT_DESCRIPTION": "Tiempo de retardo (en milisegundos)",
		"OPT_ISO_DESCRIPTION": "ISO",
		"OPT_AWBG_DESCRIPTION": "Balance de Blancos manual",
		"OPT_AWB_DESCRIPTION": "Balance de Blancos automático",
		"OPT_SS_DESCRIPTION": "Velocidad de obturacíon (en microsegundos)",
        "OPT_CUSTOMARGS_DESCRIPTION" : "Argumentos opcionales",
		"MENU_CHECKBOX": "Habilitar menús del sistema",
		"COUNTRY": "País",
		"GENERAL": "General",
		"PADRAO_UNI": "Estándar",
        "NEW" : "Nuevo",
        "INSERT" : "Insertar",
        "DESCRIPTION" : "Descrição",
        "NUMBER" : "Número",
        "ACTIVELOW" : "Ativa com sinal LOW",
        "LIGHTING" : "Iluminación",
		"OUTPUT_GPIOS" : "GPIO de saida",
		"CT_DHINIANALI" : "Inicio del ensayo",
		"CT_DHFIMANALI" : "Final del ensayo",
		"ECOLI_DHINIANALI" : "Inicio del ensayo ",
		"ECOLI_DHFIMANALI" : "Final del ensayo",
		"DATE_TIME_FORMAT": "dd/MM/yyyy HH:mm",
		"ETIQUETAS": 'Etiquetas',
		"EDIT_LOTE": 'Edición por lotes',
		"PRINT_LABELS": "Generar PDF",
		"ADD_ETIQUETAS": "Añadir etiquetas",
		"ETIQUETAS_PRINT_IN_PROGRESS": "Las etiquetas se imprimen",
		"NECESSARY_INPUT_ETIQUETA": 'Ninguna etiqueta encontrada, por favor añada una etiqueta',
		"DISABLE_EMPTY_ETIQUETA": "Llene todas las etiquetas"
	});
}

language.$inject = ['$translateProvider'];
module.exports = language;
